import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PortalVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setMessage('Invalid verification link');
    }
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify?token=${token}`);
      const data = await response.json();
      
      if (response.ok && data.verified) {
        setStatus('success');
        setMessage('Your email has been verified! You can now sign in.');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Verification failed');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Verification failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <Header currentPage="portal" />

      <section className="pt-32 pb-20">
        <div className="max-w-md mx-auto px-6">
          <div className="bg-[#111] border border-[#222] p-8 text-center">
            {status === 'loading' && (
              <>
                <Loader2 className="w-16 h-16 text-[#2CA8A0] animate-spin mx-auto mb-4" />
                <h1 className="text-xl text-white mb-2">Verifying your email...</h1>
                <p className="text-[#888] text-sm">Please wait</p>
              </>
            )}
            
            {status === 'success' && (
              <>
                <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-4" />
                <h1 className="text-xl text-white mb-2">Email Verified!</h1>
                <p className="text-[#888] text-sm mb-6">{message}</p>
                <button
                  onClick={() => navigate('/portal')}
                  className="bg-[#2CA8A0] text-black px-6 py-3 font-semibold hover:bg-[#2CA8A0] transition"
                  data-testid="verify-signin-btn"
                >
                  Sign In Now
                </button>
              </>
            )}
            
            {status === 'error' && (
              <>
                <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
                <h1 className="text-xl text-white mb-2">Verification Failed</h1>
                <p className="text-[#888] text-sm mb-6">{message}</p>
                <button
                  onClick={() => navigate('/portal')}
                  className="bg-[#333] text-white px-6 py-3 font-semibold hover:bg-[#444] transition"
                >
                  Back to Sign In
                </button>
              </>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PortalVerify;
